import request from "@utils/request";
import store from "@/store";
import cookie from "@utils/store/cookie";
const SHARE_UID_KEY = "share-uid";
/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function login(data) {
  if (!data["id"]) {
    let parent_id = store.state.app.share_uid;
    if (parent_id) {
      data["parent_id"] = parent_id;
    } else {
      data["parent_id"] = cookie.get(SHARE_UID_KEY);
      if (parent_id) data["flag"] = 1;
    }
    delete data["id"];
  }
  return request({
    url: "Login/index",
    method: "post",
    data
  });
}

export function myParent() {
  return request({
    url: "User/myParent"
  });
}

export function getLevelConf() {
  return request({
    url: "User/getLevelConf"
  });
}

export function fansCount() {
  return request({
    url: "User/fansCount"
  });
}

export function fansList(data) {
  return request({
    url: "User/fansList",
    method: "post",
    data
  });
}

/**
 * 用户手机号登录
 * @param data object 用户手机号 也只能
 */
export function loginMobile(data) {
  return request.post("/login/mobile", data, { login: false });
}

/**
 * 用户发送验证码
 * @param data object 用户手机号
 */
export function registerVerify(params) {
  return request({
    url: "/Login/sendCode",
    params
  });
}

/**
 * 用户手机号注册
 * @param data object 用户手机号 验证码 密码
 */
export function register(data) {
  return request.post("/register", data, { login: false });
}

/**
 * 用户手机号修改密码
 * @param data object 用户手机号 验证码 密码
 */
export function registerReset(data) {
  return request.post("/register/reset", data, { login: false });
}

/*
 * 领取优惠券列表
 * */
export function getCoupon(data) {
  return request({
    url: "Coupon/getList",
    method: "post",
    data
  });
}
/*
 * 领取优惠券单条
 * */
export function getCouponGetOne(data) {
  return request({
    url: "Coupon/getOne",
    method: "post",
    data
  });
}
/*
 * 点击领取优惠券
 * */
export function getCouponReceive(data) {
  return request({
    url: "Coupon/addUserCoupon",
    method: "post",
    data
  });
}

/*
 * 批量领取优惠券
 * */
export function couponReceiveBatch(couponId) {
  return request.post("/coupon/receive/batch", { couponId });
}

/*
 * 我的优惠券
 * */
export function getCouponsUser(data) {
  return request({
    url: "Coupon/getUserCoupon",
    data,
    method: "post"
  });
}

/*
 * 个人中心
 * */
export function getUser() {
  return request({
    url: "User/count"
  });
}

export function saveAlipay(data) {
  return request({
    url: "User/saveAlipay",
    method: "post",
    data
  });
}

/*
 * 用户信息
 * */
export function getUserInfo() {
  return request({
    url: "User/getUserInfo"
  });
}

/*
 * 个人中心(功能列表)
 * */
export function getMenuUser() {
  return request.get("/menu/user");
}

/*
 * 地址列表
 * */
export function getAddressList(params) {
  return request({
    url: "User/address",
    params
  });
}

/*
 * 删除地址
 * */
export function getAddressRemove(id) {
  return request.post("/address/del", { id: id });
}

/*
 * 设置默认地址
 * */
export function getAddressDefaultSet(id) {
  return request.post("/address/default/set", { id: id });
}

/*
 * 获取默认地址
 * */
export function getAddressDefault() {
  return request.get("/address/default");
}

/*
 * 获取单个地址
 * */
export function getAddress(id) {
  return request.get("/address/detail/" + id);
}

/*
 * 修改 添加地址
 * */
export function postAddress(data) {
  return request({
    url: "User/addressAdd",
    method: "post",
    data
  });
}

/*
 * 获取收藏产品
 * */
export function getCollectUser(page, limit) {
  return request.get("/collect/user", { page: page, limit: limit });
}

/*
 * 删除收藏产品
 * */
export function getCollectDel(id, category) {
  return request.post("/collect/del", { id: id, category: category });
}

/*
 * 批量收藏产品
 * */
export function postCollectAll(data) {
  return request.post("/collect/all", data);
}

/*
 * 添加收藏产品
 * */
export function getCollectAdd(id, category) {
  return request.post("collect/add", { id: id, category: category });
}

/*
 * 签到配置
 * */
export function getSignConfig() {
  return request.get("/sign/config");
}

/*
 * 签到里的签到列表
 * */
export function getSignList(page, limit) {
  return request.get("/sign/list", { page: page, limit: limit });
}

/*
 * 签到列表
 * */
export function getSignMonth(page, limit) {
  return request.get("/sign/month", { page: page, limit: limit });
}

/*
 * 签到用户信息
 * */
export function postSignUser(sign) {
  return request.post("/sign/user", sign);
}

/*
 * 签到
 * */
export function postSignIntegral(sign) {
  return request.post("/sign/integral", sign);
}

/*
 * 推广数据
 * */
export function getSpreadInfo(params) {
  return request({
    url: "Order/spread",
    params
  });
}

/*
 * 推广人列表
 * */
export function getSpreadUser(screen) {
  return request.post("/spread/people", screen);
}

/*
 * 推广人订单
 * */
export function getSpreadOrder(params) {
  return request({
    url: "Order/spread",
    params
  });
}

export function getSpreadSubOneOrder(params) {
  return request({
    url: "Order/getSpreadSubOneOrder",
    params
  });
}

/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getCommissionInfo(params) {
  return request({
    url: "User/moneyLog",
    params
  });
}

/*
 * 积分记录
 * */
export function getIntegralList(q) {
  return request.get("/integral/list", q);
}

/*
 * 提现银行
 * */
export function getBank() {
  return request.get("/extract/bank");
}

/*
 * 提现申请
 * */
export function postCashInfo(cash) {
  return request.post("/extract/cash", cash);
}

/*
 * 会员中心
 * */
export function getVipInfo() {
  return request.get("/user/level/grade");
}

/*
 * 会员等级任务
 * */
export function getVipTask(id) {
  return request.get("/user/level/task/" + id);
}

/*
 * 资金统计
 * */
export function getBalance() {
  return request({
    url: "User/getUserInfo"
  });
}

/*
 * 活动状态
 * */
export function getActivityStatus() {
  return request.get("/user/activity", {}, { login: false });
}

/**
 * 获取分销海报分类
 */
export function getPosterClass() {
  return request({
    url: "Index/getPosterClass"
  });
}

/**
 * 获取分销海报列表
 */
export function posterImgList(params) {
  return request({
    url: "Index/posterImgList",
    params
  });
}

/*
 * 活动状态
 * */
export function getSpreadImg() {
  return request.get("/spread/banner");
}

/*
 * 用户修改信息
 * */
export function postUserEdit(data) {
  return request.post("/user/edit", data);
}

/*
 * 用户修改信息
 * */
export function getChatRecord(to_uid, data) {
  return request.get("user/service/record/" + to_uid, data);
}

/*
 * 用户修改信息
 * */
export function serviceList() {
  return request.get("user/service/list");
}

/*
 * 提现
 *
 * */
export function cashWechat(data) {
  return request({
    url: "User/cashWechat",
    method: "post",
    data
  });
}

/*
 * 退出登录
 * */
export function getLogout() {
  return request.get("/logout");
}

/*
 * 绑定手机号
 * */
export function bindingPhone(data) {
  return request({
    url: "User/bindMobile",
    method: "post",
    data
  });
}

/*
 * h5切换公众号登陆
 * */
export function switchH5Login() {
  return request.post("switch_h5", { from: "wechat" });
}
/*
 * 获取推广人排行
 * */
export function getRankList(q) {
  return request.get("rank", q);
}
/*
 * 获取佣金排名
 * */
export function getBrokerageRank(q) {
  return request.get("brokerage_rank", q);
}
/**
 * 检测会员等级
 */
export function getLevelLogList(params) {
  return request({
    url: "User/getLevelLogList",
    params
  });
}

export function authGetList(params) {
  return request({
    url: "Auth/getList",
    params
  });
}

export function getAuthInfo(params) {
  return request({
    url: "Auth/getInfo",
    params
  });
}

export function submitAuthInfo(data) {
  return request({
    url: "Auth/submit",
    method: "post",
    data
  });
}

export function authOrder(params) {
  return request({
    url: "Order/authOrder",
    params
  });
}

/**
 * 核销产品列表
 * @param data
 * @constructor
 */
export function WriteOffGoodsList(data) {
  return request({
    url: "NumberProduct/getList",
    method: "post",
    data
  });
}

/**
 * 生成核销码
 * @param data
 * @constructor
 */
export function WriteOffQrcode(data) {
  return request({
    url: "NumberProduct/getQrCode",
    method: "post",
    data
  });
}

/**
 * 产品核销的记录
 * @param {Object} data
 */
export async function WriteOffLog(data) {
  return request({
    url: "NumberProduct/getRecordList",
    method: "post",
    data
  });
}

/**
 * 检测核销码的状态
 * @param {Object} data
 */
export async function checkQrStatus(data) {
  return request({
    url: "NumberProduct/checkQrStatus",
    method: "post",
    data
  });
}

export function getShopList(data) {
  return request({
    url: "NumberProduct/getShopList",
    method: "post",
    data
  });
}
